import { Card, Group, Stack, Text, useMantineTheme } from '@mantine/core'
import { LabelingTypeChip } from '@/components/annotations/LabelingTypes/LabelingTypeChip'
import { LabelGroup } from '@/components/labels/LabelGroup/LabelGroup'
import { ModelStatus } from '@/components/models/ModelStatus/ModelStatus'
import { ModelTypeChip } from '@/components/models/ModelTypeChip/ModelTypeChip'
import { ApplicationType } from '@/types/app'
import { MLModel } from '@/types/model'
import { SelectableCard } from '../../../../ui-shared/SelectableCard/SelectableCard'

type SelectableModelCardProps = {
  model: MLModel
  applicationType: ApplicationType
  isSelected?: boolean
  onClick?: () => void
}

export const SelectableModelCard = ({
  model,
  applicationType,
  isSelected,
  onClick
}: SelectableModelCardProps) => {
  const theme = useMantineTheme()

  return (
    <SelectableCard
      height={theme.other.deploymentCardHeight}
      isSelected={isSelected}
      onClick={onClick}
    >
      <Card.Section
        h={90}
        bg="gray.1"
        py="xs"
        pl="lg"
        pr="xs"
        style={{
          opacity: isSelected ? 0.5 : 1
        }}
        withBorder
      >
        <LabelGroup
          labels={
            model.dataset_version?.labels ||
            model.base_model?.dataset_version?.labels ||
            []
          }
          maxLabelsShown={2}
        />
      </Card.Section>

      <Card.Section py="sm" inheritPadding>
        <Stack align="center" gap="xs">
          <Text ta="center" size="xs" fw="bold" lineClamp={2}>
            {model.name}
          </Text>

          {model.status && <ModelStatus status={model.status} />}

          <Group gap={4} justify="center">
            <LabelingTypeChip labelingType={model.labeling_type} />

            {applicationType === ApplicationType.MultiStage && (
              <ModelTypeChip modelType={model.model_type} />
            )}
          </Group>
        </Stack>
      </Card.Section>
    </SelectableCard>
  )
}
